// export const DefaultUrl = "https://serve.brainyrms.com";
// export const DefaultUrl = "https://api.brainyrms.com";

// export const DefaultUrl = 'https://brainy.prismware.org'
export const DefaultUrl = 'https://brainy.prismware.ca'
// export const DefaultUrl = 'https://brainy-backend-wk436inj6q-uc.a.run.app'
